<template>
  <div class="start col-12">
    <div class="row">
      <div class="start-content col-12 mb-md-0 mb-11">
        <div class="start-content-header mb-10">
          <h1 class="start-content-header_title mb-9">Заполните форму</h1>
          <p class="start-content-header_descr">Оставьте заявку, либо звоните, мы пообщаемся и сами все за вас заполним:
            <a class="start-content-header_descr-link" href="tel:+74954452575">+7 495 445-25-75</a>
          </p>
        </div>
        <div class="start-content-services mb-10">
          <div class="start-content-services_header mb-md-9 mb-6">
            <h2 class="start-subtitle mb-md-0 mb-6">Услуги</h2>
            <bim-radio class="start-content-services_header-radio" name="contact" val="designer" v-model="type" label="Проектировщикам"/>
            <bim-radio class="start-content-services_header-radio" name="contact" val="manager" v-model="type" label="BIM-менеджерам"/>
            <bim-radio class="start-content-services_header-radio" name="contact" val="manufacturer" v-model="type" label="Производителям"/>
          </div>
          <div class="start-content-services_list-wrap">
            <ul class="start-content-services_list">
              <li
                class="start-content-services_list-item"
                :class="{'start-content-services_list-item--checked': type === 'designer', 'start-content-services_list-item--active': tag.checked}"
                v-for="tag in designer"
                :key="tag.id"
                @click="tag.checked = !tag.checked"
              >
                {{tag.name}}
              </li>
              <li
                class="start-content-services_list-item"
                :class="{'start-content-services_list-item--checked': type === 'manager', 'start-content-services_list-item--active': tag.checked}"
                v-for="tag in manager"
                :key="tag.id"
                @click="tag.checked = !tag.checked"
              >
                {{tag.name}}
              </li>
              <li
                class="start-content-services_list-item"
                :class="{'start-content-services_list-item--checked': type === 'manufacturer', 'start-content-services_list-item--active': tag.checked}"
                v-for="tag in manufacturer"
                :key="tag.id"
                @click="tag.checked = !tag.checked"
              >
                {{tag.name}}
              </li>
            </ul>
          </div>
        </div>
        <div class="start-content-form-wrap">
          <h3 class="start-subtitle mb-9">Контактные данные</h3>
          <form @submit.prevent="validateBeforeSubmit(formScope)" :data-vv-scope="formScope">
            <div class="start-content-form mb-10">
              <bim-input
                name="name"
                placeholder="Имя*"
                v-model="requestService.name"
                v-validate="'required'"
                data-vv-as="«Имя»"
                :valid="errors.has('name', formScope) ? false : null"
                v-tooltip="{
                  content: `${errors.first('name', formScope)}`,
                  show: errors.has('name', formScope),
                  trigger: 'manual',
                }"
              />
              <bim-input
                name="organization"
                placeholder="Компания(если есть)"
                v-model="requestService.organization"
              />
              <bim-input
                name="phone"
                placeholder="Телефон*"
                v-model="requestService.phone"
                v-validate="'required'"
                data-vv-as="«Телефон»"
                :valid="errors.has('phone', formScope) && !errors.has('name', formScope) || !validPhone && requestService.phone ? false : null"
                v-tooltip="{
                  content: 'Номер телефона должен содержать только цифры и быть в пределах от 6 до 15 символов',
                  show: (errors.has('phone', formScope) && !errors.has('name', formScope) || !validPhone && requestService.phone) && !errors.has('name', formScope),
                  trigger: 'manual',
                }"
              />
              <bim-input
                name="email"
                placeholder="Электронная почта*"
                v-model="requestService.email"
                v-validate="'required|email'"
                data-vv-as="«Электронная почта»"
                :valid="errors.has('email', formScope) && validPhone && !errors.has('name', formScope) ? false : null"
                v-tooltip="{
                  content: `${errors.first('email', formScope)}`,
                  show: errors.has('email', formScope) && validPhone && !errors.has('name', formScope),
                  trigger: 'manual',
                }"
                @keyup.enter="$emit('submit')"
              />
            </div>
            <div class="start-content-form_button-wrap">
              <bim-button
                width="176"
                class="start-content-form_button mb-md-0 mb-6"
                size="l"
                label="Отправить запрос"
                :disabled="loading"
              ></bim-button>
              <p class="start-content-form_agree ml-9">Нажимая на кнопку, вы принимаете
                <a href="/agreement/" target="_blank" class="start-content-form_agree-link">пользовательское соглашение</a>
                и
                <a href="/privacy/" target="_blank" class="start-content-form_agree-link">политику конфиденциальности</a>
              </p>
            </div>
          </form>
        </div>
      </div>
      <!-- <div class="start-more offset-md-1 col-md-4 col-12">
       <img class="start-more_img mb-24" src="/dist/assets/front_white/img/start/smiling-man.svg" role="presentation">
       <a class="start-more_link" href="/services/">Узнать подробнее об услугах</a>
      </div> -->
    </div>
  </div>
</template>

<script>
import bimInput from '@bimlib/components/bimInput'
import bimButton from '@bimlib/components/bimButton'
import bimRadio from '@bimlib/components/bimRadio'

export default {
  components: {
    bimInput,
    bimButton,
    bimRadio,
  },
  props: {},
  data () {
    return {
      type: 'designer',
      UUID:'',
      ya_login:'',
      utm:'',
      designer: [
        {
          name: 'Получить ТКП',
          checked: false,
          id: 10,
        },
        {
          name: 'Запросить прайс-листы',
          checked: false,
          id: 11,
        },
        {
          name: 'Рассчитать проект',
          checked: false,
          id: 12,
        },
        {
          name: 'Подобрать аналоги',
          checked: false,
          id: 13,
        },
        {
          name: 'Убрать дубли в номенклатуре',
          checked: false,
          id: 14,
        },
        {
          name: 'Другое',
          checked: false,
          id: 15,
        },
      ],
      manager: [
        {
          name: 'Сопоставить номенклатуру и BIM-модели',
          checked: false,
          id: 20,
        },
        {
          name: 'Сформировать EIR',
          checked: false,
          id: 21,
        },
        {
          name: 'Разработать BEP',
          checked: false,
          id: 22,
        },
        {
          name: 'Провести аудит BIM-модели',
          checked: false,
          id: 23,
        },
        {
          name: 'Запросить шаблоны семейств с параметрами ГОСТ и ТУ',
          checked: false,
          id: 24,
        },
        {
          name: 'Другое',
          checked: false,
          id: 25,
        },
      ],
      manufacturer: [
        {
          name: 'Заказать BIM-модель',
          checked: false,
          id: 30,
        },
        {
          name: 'Создание цифровых каталогов',
          checked: false,
          id: 31,
        },
        {
          name: 'Заказать AR-модель',
          checked: false,
          id: 32,
        },
        {
          name: 'Получить информацию о строящихся объектах',
          checked: false,
          id: 33,
        },
        {
          name: 'Узнать потребности в закупке материалов на стройплощадках',
          checked: false,
          id: 34,
        },
        {
          name: 'Маркетинг на портале (размещение видео и статей, эл.рассылки)',
          checked: false,
          id: 35,
        },
        {
          name: 'Другое',
          checked: false,
          id: 36,
        },
      ],
      requestService: {
        servicesList: [],
        name: '',
        organization: '',
        phone: '',
        email: '',
      },
      formScope: 'requestService',
      validPhone: false,
      formSent: false,
      loading: false,
      formCatcher: {
        location: '',
        name: '',
        phone: '',
        email: '',
        organization: '',
        inn: '',
        date: '',
        id: '',
      },
    }
  },
  mounted() {
    this.UUID = localStorage.getItem('UUID')
    this.ya_login = this.getCookie('yandex_login') || "";
    this.utm = window.location.href.indexOf("utm_source") > -1 ? new URL(window.location.href).search : '' || "";
    window.location.href.indexOf("utm_source") > -1 ? localStorage.setItem("__feedback_utm", this.utm) : '' || "";
  },
  watch: {
    'requestService.phone' (val) {
      if (!this.formSent) {
        this.$store.dispatch('validationPhone', val)
        this.validPhone = this.$store.getters.isValid
      } else {
        this.formSent = false
      }
      localStorage.setItem("__feedback_phone", val)
    },
    'requestService.email'(val) {
      if(val.length >= this.formCatcher.email.length) {
        this.formCatcher.email = val
      }
      localStorage.setItem("__feedback_email", val)
    },
    'requestService.name'(val) {
      if(val.length >= this.formCatcher.name.length) {
        this.formCatcher.name = val
      }
      localStorage.setItem("__feedback_name", val)
    },
    'requestService.organization'(val) {
      if(val.length >= this.formCatcher.organization.length) {
        this.formCatcher.organization = val
      }
      localStorage.setItem("__feedback_organization", val)
    },
  },
  computed: {
    servicesListFilter () {
      let checkDesigner = this.designer.filter(service => service.checked),
          checkManager = this.manager.filter(service => service.checked),
          checkManufacturer = this.manufacturer.filter(service => service.checked)
      return checkDesigner.concat(checkManager).concat(checkManufacturer)
    },
  },
  methods: {
    getCookie(name) {
      let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    cleanLocalStorageFromForm() {
      localStorage.removeItem("__feedback_phone")
      localStorage.removeItem("__feedback_email")
      localStorage.removeItem("__feedback_name")
      localStorage.removeItem("__feedback_inn")
      localStorage.removeItem("__feedback_organization")
      localStorage.removeItem("__feedback_utm")
    },
    sendFormCatcher() {
      const form = Object.fromEntries(
        ["phone", "email", "name", "inn", "utm"].map(name => {
          const value = localStorage.getItem("__feedback_" + name) || ""
          return [name, value]
        })
      )

      const data = new FormData();
      data.append('key', this.UUID);
      data.append('lead', JSON.stringify(Object.assign(this.formCatcher, form)));

      axios.post('/?a=formCatcher', data)
    },
    changeSlide (val) {
      if (val !== this.slide) {
        this.slide = ''
        setTimeout(() => this.slide = val, 220)
      }
    },
    validateBeforeSubmit (scope) {
      if (this.loading) return

      this.$validator
        .validateAll(scope)
        .then(result => {
          this.$store.dispatch('validationPhone', this.requestService.phone)
          this.validPhone = this.$store.getters.isValid

          if (result && this.validPhone) {
            this.loading = true;

            const data = new FormData()
            const form = {
              phone: localStorage.getItem("__feedback_phone") || "",
              first_name: localStorage.getItem("__feedback_name") || "",
              inn: localStorage.getItem("__feedback_inn") || "",
              email: localStorage.getItem("__feedback_email") || "",
              organization: localStorage.getItem("__feedback_organization") || "",
              ya_login: this.ya_login,
              utm: localStorage.getItem("__feedback_utm") || "",
            }
            for (let i in form) {
              data.append(i, form[i])
            }
            data.append("UUID", this.UUID);
            if (this.servicesListFilter.length > 0) {
              this.requestService.servicesList = this.servicesListFilter
              data.append('servicesArray', JSON.stringify(this.requestService.servicesList))
            }
            // '/service_order' старый запрос
            axios
              .post('/?m=Statics&a=form_request', data)
              .then(response => {
                if (response.data.success) {
                  this.requestService.name = ''
                  this.requestService.organization = ''
                  this.requestService.phone = ''
                  this.requestService.email = ''
                  this.designer.forEach(tag => tag.checked = false)
                  this.manager.forEach(tag => tag.checked = false)
                  this.manufacturer.forEach(tag => tag.checked = false)

                  this.$nextTick(() => {
                    this.$validator.reset()
                  })
                  this.formSent = true
                  this.validPhone = true

                  this.$toast('Запрос успешно отправлен!')

                } else {
                  this.$toast('Что-то пошло не так, попробуйте снова', {title: 'Ошибка... :('})
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.loading = false
              })
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './src/front_white/sass/components/color';
@import './src/front_white/sass/components/settings';

.start {
  padding-top    : 75px;
  padding-bottom : 100px;

  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    padding-top : 45px;
  }
}

.start-subtitle {
  font-size   : 18px;
  font-weight : bold;
}

.start-content {

  &-header_title {
    font-size   : 42px;
    font-weight : bold;
  }

  &-header_descr {
    font-size   : 18px;
    font-weight : normal;
    max-width   : 560px;

    &-link {
      color : $active;
    }
  }

  &-services_header {
    display : flex;

    @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
      flex-direction : column;
    }

    &-radio {
      margin-left : 14px;

      &:first-child {
        margin-left : 24px;
      }

      @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
        margin-bottom : 14px;
        margin-left   : 0px;
      }
    }
  }

  &-services_list {
    display    : flex;
    flex-wrap  : wrap;
    min-height : 115px;
    // width: 85%;
  }

  &-services_list-wrap {
    min-height : 115px;
  }

  &-services_list-item {
    cursor           : pointer;
    font-size        : 14px;
    display          : flex;
    align-items      : center;
    justify-content  : center;
    background-color : #f6f6f6;
    margin-top       : 14px;
    padding          : 10px 24px;
    height           : 42px;
    border-radius    : 21px;
    margin-right     : 14px;
    opacity          : 40%;

    @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
      font-size : 12px;
    }

    &--active {
      background-color : $active !important;
      color            : #fff;
    }

    &--checked {
      background-color : #f2fbfa;
      opacity          : 100%;
    }

    &:hover {
      background-color : $active;
      color            : #fff;
    }
  }

  &-form {
    display               : grid;
    grid-template-columns : 1fr 1fr;
    grid-gap              : 14px;
    width                 : 40%;

    @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
      grid-template-columns : 1fr;
      width                 : 100%;
    }
  }

  &-form_button-wrap {
    display     : flex;
    align-items : center;
    @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
      flex-direction : column;
    }
  }

  &-form_agree {
    font-size : 12px;
    // max-width: 370px;
  }

  &-form_agree-link {
    border-bottom : 1px solid $active;
  }
}

.start-more {
  display         : flex;
  flex-direction  : column;
  justify-content : center;
  align-items     : center;

  &_link {
    max-width      : 255px;
    text-align     : center;
    font-size      : 18px;
    border-bottom  : 1px solid $active;
    padding-bottom : 4px;
  }
}

</style>
